
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ContractType, Currency } from "@/lib/types";
import { ContractFormValues } from "./ContractFormSchema";
import { ContractFinancialDetailsSection } from "./sections/ContractFinancialDetailsSection";
import { CompanyDetails } from "@/lib/api/companyRegister";

interface ContractFinancialDetailsProps {
  form: UseFormReturn<ContractFormValues>;
  selectedContractType: ContractType | null;
  renewalDate: Date | null;
  setCurrencyModalOpen: (open: boolean) => void;
  handleCurrencyCreated?: (currency: Currency) => void;
  servicesTotal?: number;
}

export function ContractFinancialDetails({ 
  form, 
  selectedContractType,
  renewalDate,
  setCurrencyModalOpen,
  handleCurrencyCreated,
  servicesTotal
}: ContractFinancialDetailsProps) {
  const { t } = useTranslation();

  // We delegate all the component's functionality to the ContractFinancialDetailsSection
  return (
    <ContractFinancialDetailsSection
      form={form}
      selectedContractType={selectedContractType}
      renewalDate={renewalDate}
      setCurrencyModalOpen={setCurrencyModalOpen}
      servicesTotal={servicesTotal}
    />
  );
}
